

<div class="rec-container">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <h2>Searches available to our customers:</h2>
        <p>&nbsp;</p>
        <!--<p style="font-size: 20px; color: red;">*** Search Results Export is now Active ***</p>-->
      </div>
    </div>
    <!--<div class="row">
      <div class="col-sm-4 zoom">
        <p style="font-size: 14px;">&nbsp;</p>
          <a (click)="linkClick('propertySearch')" >
            <img src="images/Property_Search_200.jpg" style="width: 167px; height: 100px" />
          </a>
      </div>
      <div class="col-sm-8">
        <p style="font-size: 16px;"><strong>Property Search</strong></p>
        <p style="font-size: 14px;"><strong>The Property Search is primarily designed for property owners. It allows you to search by broad categories of document types.</strong></p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">&nbsp;</div>
    </div>-->
    <div class="row">
      <div class="col-sm-4 zoom">
        <a (click)="linkClick('RecordedLand')">
          <p style="font-size: 14px;">&nbsp;</p>
          <img src="images/DeedBook.jpeg" style="width: 167px; height: 100px" />
        </a>
      </div>
      <div class="col-sm-8">
        <p style="font-size: 16px;"><strong>Land Records 1962 - Present</strong></p>
        <p style="font-size: 14px;"><strong>You may search the Land records by owner's name, date range, document type, and Book/Page reference. These searches will provide index information stored on the system; you may also view document images, and download them to your own system.</strong></p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">&nbsp;</div>
    </div>
    <!--<div class="row">
      <div class="col-sm-4 zoom">
        <a (click)="linkClick('registeredLand')">
          <p style="font-size: 14px;">&nbsp;</p>
          <img src="images/RegisteredLand.jpg" style="width: 167px; height: 100px" />
        </a>
      </div>
      <div class="col-sm-8">
        <p style="font-size: 14px;">Registered Land</p>
        <p style="font-size: 14px">You may search the Registered Land records by date range, name, address, and/or document type. These searches will provide index information stored on the system and allow you to download document images. You may also view the certificates issued as a result of the registration process.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">&nbsp;</div>
    </div>-->
    <div class="row">
      <div class="col-sm-4 zoom">
        <a (click)="linkClick('RecordedLandPlans')">
          <p style="font-size: 14px;">&nbsp;</p>
          <img src="images/Plans.jpeg" style="width: 167px; height: 100px" />
        </a>
      </div>
      <div class="col-sm-8">
        <p style="font-size: 16px;"><strong>Plans</strong></p>
        <p style="font-size: 14px;"><strong>This search provides access to land plans.</strong></p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">&nbsp;</div>
    </div>
    <!--<div class="row">
      <div class="col-sm-4 zoom">
        <a (click)="linkClick('RegisteredLandPlans')">
          <p style="font-size: 14px;">&nbsp;</p>
          <img src="images/RegisteredLandPlans.jpg" style="width: 167px; height: 100px" />
        </a>
      </div>
      <div class="col-sm-8">
        <p style="font-size: 14px;">Registered Land Plans</p>
        <p style="font-size: 14px;">This search provides access to plans that originate with the Land Court that are attached to specific Certificates of Title.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">&nbsp;</div>
    </div>-->
    <div class="row">
      <div class="col-sm-4 zoom">
        <a (click)="linkClick('UnindexedRecords')">
          <p style="font-size: 14px;">&nbsp;</p>
          <img src="images/UnindexedRecords2.jpg" style="width: 167px; height: 100px" />
        </a>
      </div>
      <div class="col-sm-8">
        <p style="font-size: 16px;"><strong>Unindexed Land Records 1840 - 1962</strong></p>
        <p style="font-size: 14px;"><strong>For records prior to 1962, you may access images of our index books for the period of 1840-1962. From the index pages, you can enter the book and pages of the document images you wish to examine.</strong></p>
      </div> 
    </div>
  </div>
</div>
